import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { NavItem } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { getLinkForOrderFulfillmentRoute } from "../../utils/RouterUtil";

import { getComponentByName } from "../LazyWrapper";
const IdamCompatibleLogoutLink = getComponentByName("cia_ui/IdamCompatibleLogoutLink");

type Props = {
    [x: string]: any;
};

export default class NavItemLink extends React.Component<Props> {
    static readonly contextTypes = {
        intl: PropTypes.object
    };

    render() {
        const props = this.props;
        const otherProps = _.omit(props, ["isOrderFulfillment", "isNonBackendUrl", "to", "isLogout", "text"]);

        if (props.isLogout) {
            const formatMessage = this.context.intl.formatMessage;
            return (
                <li role="presentation">
                    <IdamCompatibleLogoutLink text={formatMessage({ id: props.text })} />
                </li>
            );
        }
        if (props.isNonBackendUrl) {
            return (
                <NavItem href={props.to} {...otherProps}>
                    {props.children}
                </NavItem>
            );
        }

        if (props.isOrderFulfillment) {
            return (
                <NavItem href={getLinkForOrderFulfillmentRoute(props.to || "")} {...otherProps}>
                    {props.children}
                </NavItem>
            );
        }
        if (props.to === "/") {
            return (
                <IndexLinkContainer to={props.to} {...otherProps}>
                    <NavItem>{props.children}</NavItem>
                </IndexLinkContainer>
            );
        } else {
            return (
                <LinkContainer to={props.to} {...otherProps}>
                    <NavItem>{props.children}</NavItem>
                </LinkContainer>
            );
        }
    }
}
